import Home from '../views/Home.vue'
export default {
  path: '/library',
  name: '主题申报',
  component: Home,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: false,
  children: [
    {
      path: '/library',
      component: () =>
                import('../views/library/indexOut'),
      name: '主题申报',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/library/index',
      component: () =>
                import('../views/library/index'),
      name: '示范图书馆',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/library/contrast/details',
      component: () =>
                import('../views/library/details/comContrast/details/index.vue'),
      name: '评比详情',
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
